// Putanja (string) za objekat rute ili putanju, npr. routePath({ name: 'zastita' }) -> '/zastita'.
// Nepostojeca ruta ili nedostajuci parametar daju '' umesto greske, da jedan los link ne sruši stranicu.
export function useRoutePath() {
  const router = useRouter()

  return (to: string | Record<string, any>): string => {
    if (typeof to === 'string') return to

    try {
      return router.resolve(to as any).fullPath
    } catch (e) {
      return ''
    }
  }
}
